import React from 'react';
import './Header.css';

const headers = ['Date', 'Channel', 'Sender', 'Message'];

export default ({
  ...props
}) => {
  return (
    <thead>
      <tr className='messages-overview-header-container'>
        { headers.map((header, index) => <th key={header} className='overview-header-text'>{header}</th>) }
      </tr>
    </thead>
  );
};
